import { render } from "./UserStatistics.vue?vue&type=template&id=6c6c0824&scoped=true"
import script from "./UserStatistics.vue?vue&type=script&lang=js"
export * from "./UserStatistics.vue?vue&type=script&lang=js"

import "./UserStatistics.vue?vue&type=style&index=0&id=6c6c0824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6c0824"]])

export default __exports__